import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import { useLanguage } from '../hooks'
import cn from 'classnames'

import * as st from '@assets/styl/upcomingProjects.module.styl'

type ImageFile = {
  childImageSharp: { gatsbyImageData: IGatsbyImageData }
} | null

export type UpcomingProjectProps = {
  // facades: string[]
  facade: string
  facadeMobile: string
  facadeHover: string
  facadeHome: string
  image1: string
  image1Mobile: string
  image2: string
  image2Mobile: string
  facadeHomeMobile: string
  facadeHomeHover: string
  name: string
  title: string
  description: string
  neighborhood: string
  city: string
  tag: string
  url: string
  feature: string
  image1File: ImageFile
  image1MobileFile: ImageFile
  image2File: ImageFile
  image2MobileFile: ImageFile
}

const OptimizedImage = ({
  file,
  fallbackSrc,
  alt,
}: {
  file: ImageFile
  fallbackSrc: string
  alt: string
}) => {
  const image = getImage(file || undefined)
  return image ? (
    <GatsbyImage image={image} alt={alt} />
  ) : (
    <img src={fallbackSrc} alt={alt} loading="lazy" />
  )
}

const UpcomingProject = ({
  // facades,
  facade,
  facadeMobile,
  facadeHover,
  facadeHome,
  image1,
  image1Mobile,
  image2,
  image2Mobile,
  facadeHomeMobile,
  facadeHomeHover,
  name,
  title,
  description,
  neighborhood,
  city,
  tag,
  url,
  feature,
  image1File,
  image1MobileFile,
  image2File,
  image2MobileFile,
}: UpcomingProjectProps) => {
  const { t } = useLanguage()

  const safeTitle = title || ''
  const safeDescription = description || ''

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className={st.core}>
      <div className={st.header}>
        <h3>{name}</h3>
        <p>
          <b>{tag}</b> / {neighborhood} / {city}
        </p>
      </div>

      {facade && (
        <div className={st.cover}>
          <OptimizedImage
            file={isMobile ? image1MobileFile : image1File}
            fallbackSrc={isMobile ? image1Mobile : image1}
            alt="Fachada 1"
          />
        </div>
      )}

      <div className={st.details}>
        {image2 && (
          <div className={st.image}>
            <OptimizedImage
              file={isMobile ? image2MobileFile : image2File}
              fallbackSrc={isMobile ? image2Mobile : image2}
              alt="Fachada 2"
            />
          </div>
        )}
        <div className={st.content}>
          <div className={st.description}>
            <h4
              dangerouslySetInnerHTML={{
                __html: safeTitle.replace(/\n/g, '<br>'),
              }}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: safeDescription.replace(/\n/g, '<br>'),
              }}
            />
          </div>
          <a
            className="btn light"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('Releases.visitWebsite')}
          </a>
        </div>
      </div>
    </div>
  )
}

export default UpcomingProject
